module.exports = __webpack_public_path__ + "static/Optimization-a338d50b588407df35ab0a4d8a30582f.svg";